import React from 'react';

const ESTADOS = {
  running: { label: 'EN CURSO', cls: 'bg-teal-50 border-teal-200 text-teal-800' },
  completed: { label: 'COMPLETADO', cls: 'bg-green-50 border-green-200 text-green-800' },
  completed_with_errors: { label: 'COMPLETADO CON ERRORES', cls: 'bg-orange-50 border-orange-200 text-orange-800' },
  cancelled: { label: 'CANCELADO', cls: 'bg-gray-50 border-gray-200 text-gray-800' },
  interrupted: { label: 'INTERRUMPIDO', cls: 'bg-red-50 border-red-200 text-red-800' },
  error: { label: 'ERROR', cls: 'bg-red-50 border-red-200 text-red-800' },
};

const fmt = (ts) => (ts ? new Date(ts * 1000).toLocaleString('es-AR') : '—');

const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-2">
    <span className="text-gray-600">{label}</span>
    <span className="font-semibold" data-testid={testId}>{value}</span>
  </div>
);

export const LowGrandesStatus = ({ grandes }) => {
  if (!grandes) return null;
  const est = ESTADOS[grandes.estado] || ESTADOS.error;
  const ck = grandes.checkpoint || {};
  return (
    <div className={`p-3 rounded-lg border text-xs space-y-2 ${est.cls}`} data-testid="low-grandes-status">
      <div className="flex justify-between items-center">
        <span className="text-sm font-bold">LOW PDFs grandes</span>
        <span className="font-bold" data-testid="low-grandes-estado">
          {est.label}{grandes.estado_derivado ? ' (sin heartbeat)' : ''}
        </span>
      </div>
      {grandes.sin_avance && (
        <p className="font-semibold text-amber-700" data-testid="low-grandes-sin-avance">
          SIN AVANCE desde {grandes.last_progress_at ? new Date(grandes.last_progress_at).toLocaleString('es-AR') : '—'} (proceso vivo)
        </p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1">
        <Row label="Documentos inspeccionados" value={`${grandes.docs_scanned} / ${grandes.total_docs}`} testId="low-grandes-docs-scanned" />
        <Row label="Pequeños omitidos (≤150 MB)" value={grandes.small_docs_skipped} testId="low-grandes-small-skipped" />
        <Row label="PDF grandes encontrados" value={grandes.large_docs_found} testId="low-grandes-large-found" />
        <Row label="PDF grandes completados" value={grandes.large_docs_completed} testId="low-grandes-large-completed" />
        <Row label="PDF grandes con errores" value={grandes.large_docs_failed} testId="low-grandes-large-failed" />
        <Row label="Páginas renderizadas" value={grandes.pages_rendered} testId="low-grandes-pages-rendered" />
        <Row label="Páginas ya existentes" value={grandes.pages_existing} testId="low-grandes-pages-existing" />
        <Row label="Páginas fallidas/sospechosas" value={grandes.pages_failed} testId="low-grandes-pages-failed" />
      </div>
      <div className="space-y-0.5">
        <p data-testid="low-grandes-last-doc">
          Último documento: <b>{grandes.last_doc_name || '—'}</b>
          {ck.manual_id ? ` · última página completada: ${ck.last_completed_page ?? 0}${ck.doc_done ? ' (documento terminado)' : ''}` : ''}
        </p>
        {grandes.page_in_progress && (
          <p>Página en curso: {grandes.page_in_progress.page}</p>
        )}
        <p>Inicio: {fmt(grandes.started_at)} · Fin: {fmt(grandes.finished_at)}</p>
        <p>Último heartbeat: {fmt(grandes.heartbeat_ts)} · Último avance: {fmt(grandes.progress_ts)}</p>
        {grandes.error && <p className="font-semibold">{grandes.error}</p>}
      </div>
      {grandes.suspect_pages?.length > 0 && (
        <div data-testid="low-grandes-suspect-pages">
          <p className="font-semibold">Páginas sospechosas (2 interrupciones consecutivas):</p>
          {grandes.suspect_pages.map((p) => (
            <p key={`${p.manual_id}-${p.r2_file_key}-${p.page}`}>{p.manual_id} · página {p.page}</p>
          ))}
        </div>
      )}
      {grandes.failed_docs?.length > 0 && (
        <p data-testid="low-grandes-failed-docs">Documentos no obtenidos: {grandes.failed_docs.length}</p>
      )}
    </div>
  );
};
